import { StarFill } from "./constants";

export const getStarFill = (rating: number, starNumber: number ): StarFill => {
  const subtractRating = 1 - (starNumber - rating);

  if (starNumber <= rating || subtractRating > 0.75) {
    return StarFill.Full;
  } 
  
  if (subtractRating >= 0.25 && subtractRating <= 0.75) {
    return StarFill.Half;
  } 
  
  return StarFill.Empty;
};

export const generateStars = (renderer: (value: number) => JSX.Element) => Array(5).fill(0).map((_, i) => renderer(i));
